(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slumber-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
      this.header.querySelectorAll('details').forEach((details) => details.removeAttribute('open'));
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function resetSlumberDrawerAccordions(drawerRoot) {
    drawerRoot.querySelectorAll('.slumber-header-drawer__submenu-list').forEach((submenu) => {
      submenu.hidden = true;
    });
    drawerRoot.querySelectorAll('.slumber-header-drawer__submenu-toggle').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    drawerRoot.querySelectorAll('.slumber-header-drawer__item.is-open, .slumber-header-drawer__submenu-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
    });
  }

  function toggleSlumberDrawerSubmenu(toggle) {
    const controlsId = toggle.getAttribute('aria-controls');
    const submenu = controlsId ? document.getElementById(controlsId) : null;
    if (!submenu) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const listItem = toggle.closest('.slumber-header-drawer__item, .slumber-header-drawer__submenu-item');

    if (isExpanded) {
      submenu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      listItem?.classList.remove('is-open');
    } else {
      submenu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      listItem?.classList.add('is-open');
    }
  }

  function initSlumberDrawerSubmenus(drawerRoot) {
    drawerRoot.querySelectorAll('.slumber-header-drawer__submenu-toggle').forEach((toggle) => {
      if (toggle.dataset.slumberDrawerBound) return;
      toggle.dataset.slumberDrawerBound = 'true';

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleSlumberDrawerSubmenu(toggle);
      });

      toggle.addEventListener('keydown', (event) => {
        if (event.code !== 'Enter' && event.code !== 'Space') return;
        event.preventDefault();
        event.stopPropagation();
        toggleSlumberDrawerSubmenu(toggle);
      });
    });

    const headerDrawer = drawerRoot.closest('header-drawer');
    const mainDetails = headerDrawer?.querySelector('#Details-menu-drawer-container');
    if (mainDetails && !mainDetails.dataset.slumberResetBound) {
      mainDetails.dataset.slumberResetBound = 'true';
      mainDetails.addEventListener('toggle', () => {
        if (!mainDetails.hasAttribute('open')) {
          resetSlumberDrawerAccordions(drawerRoot);
        }
      });
    }
  }

  function initSlumberPredictiveSearch() {
    document.querySelectorAll('.slumber-header__search predictive-search').forEach((element) => {
      if (element.dataset.slumberPredictiveBound) return;
      element.dataset.slumberPredictiveBound = 'true';

      const syncPredictiveSearchHeight = () => {
        const results = element.querySelector('[data-predictive-search]');
        if (!results || !element.hasAttribute('open')) return;

        results.style.removeProperty('max-height');
        results.style.height = 'auto';
      };

      const attributeObserver = new MutationObserver(syncPredictiveSearchHeight);
      attributeObserver.observe(element, { attributes: true, attributeFilter: ['open', 'loading', 'results'] });

      const results = element.querySelector('[data-predictive-search]');
      if (results) {
        const contentObserver = new MutationObserver(syncPredictiveSearchHeight);
        contentObserver.observe(results, { childList: true, subtree: true });
      }
    });
  }

  function bindCartIconToDrawer() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || cartLink.getAttribute('role') === 'button') return;

    const bind = () => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (typeof cartDrawer?.setHeaderCartIconAccessibility === 'function') {
        cartDrawer.setHeaderCartIconAccessibility();
      }
    };

    if (customElements.get('cart-drawer')) {
      bind();
      return;
    }

    customElements.whenDefined('cart-drawer').then(bind);
  }

  function initSlumberHeaderEnhancements() {
    document.querySelectorAll('.slumber-header-drawer').forEach(initSlumberDrawerSubmenus);
    initSlumberPredictiveSearch();
    bindCartIconToDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlumberHeaderEnhancements);
  } else {
    initSlumberHeaderEnhancements();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.slumber-header-drawer')) {
      initSlumberHeaderEnhancements();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
